// Mock data for Godrej Elaris real estate landing page

export const SITE = {
  projectName: "Godrej Elaris",
  location: "At Magarpatta–Mundhwa, Pune",
  phone: "+91 8087536102",
  phoneRaw: "+918087536102",
  email: "sales@newlaunchmagarpatta.online",
  leadNotifyEmail: "sansarsales333@gmail.com",
  whatsapp: "918087536102",
  whatsappMessage:
    "Hello, I am interested in Godrej Elaris Magarpatta Pune. Please share the details.",
  tagline: "Luxury Apartments at Magarpatta–Mundhwa, Pune",
  floors: "B+G+30 floors",
  startingPrice: "₹ 1.47 Cr*",
  retailPrice: "₹ 3.00 Cr*",
  reraStatus: "RERA Registered*",
  channelPartner: "Bhima Kamble",
  agentRera: "A52100043100",
  projectRera: "PM1260002501385",
  siteAddress:
    "Magarpatta Rd, Mundhwa Industrial Area, Mundhwa, Pune, Maharashtra 411036",
  privacyPolicyUrl: "/privacy-policy",
  topDisclaimer:
    "Disclaimer: This is not the official developer website. This website is operated by Bhima Kamble, an authorized channel partner for Godrej Elaris, for informational and marketing purposes.",
};

export const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1580041065738-e72023775cdc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc2OTU0MDEzfDA&ixlib=rb-4.1.0&q=85",
];

export const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1611094016919-36b65678f3d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2OTU0MDE3fDA&ixlib=rb-4.1.0&q=85";

export const PRICE_LIST = [
  {
    id: "retail",
    category: "Retail Space",
    type: "Retail Space",
    size: "On Request",
    price: "₹ 3.00 Cr*",
    suffix: "Onwards",
  },
  {
    id: "2bhk",
    category: "Apartments",
    type: "2 BHK",
    size: "915 Sq.Ft",
    price: "₹ 1.47 Cr*",
    suffix: "Onwards",
  },
  {
    id: "3bhk",
    category: "Apartments",
    type: "3 BHK",
    size: "1166 - 1440 Sq.Ft",
    price: "₹ 1.89 Cr*",
    suffix: "Onwards",
  },
  {
    id: "35bhk",
    category: "Apartments",
    type: "3.5 BHK",
    size: "1934 Sq.Ft",
    price: "₹ 3.15 Cr*",
    suffix: "Onwards",
  },
  {
    id: "4bhk",
    category: "Apartments",
    type: "4 BHK",
    size: "1950 Sq.Ft",
    price: "₹ 3.59 Cr*",
    suffix: "Onwards",
  },
];

export const HIGHLIGHTS = [
  "Excellent freeway and city road access",
  "Close to Seasons Mall and Amanora Mall",
  "Easy access to Pune Railway Station and Airport",
  "Near Magarpatta IT Park and Hadapsar IT center",
  "Short commute to reputable schools, hospitals and universities",
  "Premium construction by trusted developer",
  "B+G+30 floors modern high-rise towers",
  "Vastu-compliant layouts with maximum ventilation",
];

export const AMENITIES = [
  { name: "Swimming Pool", icon: "Waves" },
  { name: "Badminton Court", icon: "Trophy" },
  { name: "Kids Play Area", icon: "Baby" },
  { name: "Yoga Deck", icon: "Flower2" },
  { name: "Spa & Wellness", icon: "Sparkles" },
  { name: "Gymnasium", icon: "Dumbbell" },
  { name: "Jogging Track", icon: "Footprints" },
  { name: "Billiards Room", icon: "CircleDot" },
  { name: "Clubhouse", icon: "Home" },
  { name: "Landscaped Gardens", icon: "Trees" },
  { name: "CCTV Security", icon: "ShieldCheck" },
  { name: "Power Backup", icon: "Zap" },
];

export const GALLERY = [
  {
    src: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc2OTU0MDEzfDA&ixlib=rb-4.1.0&q=85",
    caption: "Premium Living Room",
  },
  {
    src: "https://images.unsplash.com/photo-1686056040370-b5e5c06c4273?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc2OTU0MDEzfDA&ixlib=rb-4.1.0&q=85",
    caption: "Modern Open-plan Layout",
  },
  {
    src: "https://images.pexels.com/photos/8082229/pexels-photo-8082229.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Elegant Interiors",
  },
  {
    src: "https://images.unsplash.com/photo-1639663742190-1b3dba2eebcf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2OTU0MDE3fDA&ixlib=rb-4.1.0&q=85",
    caption: "City-view Residences",
  },
  {
    src: "https://images.unsplash.com/photo-1638972691611-69633a3d3127?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2OTU0MDE3fDA&ixlib=rb-4.1.0&q=85",
    caption: "Designer Living Spaces",
  },
  {
    src: "https://images.unsplash.com/photo-1761971976592-58882ab1cacc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjbHViaG91c2V8ZW58MHx8fHwxNzc2OTU0MDIxfDA&ixlib=rb-4.1.0&q=85",
    caption: "Grand Clubhouse",
  },
  {
    src: "https://images.unsplash.com/photo-1761971976407-db2374e4ae12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjbHViaG91c2V8ZW58MHx8fHwxNzc2OTU0MDIxfDA&ixlib=rb-4.1.0&q=85",
    caption: "Lounge & Bar",
  },
  {
    src: "https://images.pexels.com/photos/36547603/pexels-photo-36547603.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    caption: "Contemporary Amenities",
  },
];

export const LOCATION_POINTS = [
  { place: "Magarpatta City", time: "4 mins" },
  { place: "Koregaon Park", time: "8 mins" },
  { place: "Ghorpuri Railway Station", time: "12 mins" },
  { place: "Upcoming Coastal Road", time: "7 mins" },
  { place: "St. Mira's College", time: "10 mins" },
  { place: "Columbia Asia Hospital Pune", time: "7 mins" },
  { place: "Seasons Mall", time: "3 mins" },
  { place: "Deutsche Bank Corridor", time: "4 mins" },
  { place: "Amanora Mall", time: "6 mins" },
  { place: "Pune International Airport", time: "25 mins" },
  { place: "Hadapsar IT Park", time: "5 mins" },
  { place: "Symbiosis College", time: "12 mins" },
];

export const FLOOR_PLANS = [
  {
    type: "2 BHK",
    size: "915 Sq.Ft",
    price: "₹ 1.47 Cr*",
    img: "https://images.unsplash.com/photo-1580041065738-e72023775cdc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc2OTU0MDEzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    type: "3 BHK",
    size: "1166 - 1440 Sq.Ft",
    price: "₹ 1.89 Cr*",
    img: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhcGFydG1lbnR8ZW58MHx8fHwxNzc2OTU0MDEzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    type: "4 BHK",
    size: "1950 Sq.Ft",
    price: "₹ 3.59 Cr*",
    img: "https://images.unsplash.com/photo-1639663742190-1b3dba2eebcf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc2OTU0MDE3fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const FAQS = [
  {
    q: "Where is Godrej Elaris located?",
    a: "Godrej Elaris is located at the prime address of Magarpatta–Mundhwa, Pune, offering excellent connectivity to IT parks, malls, and educational institutions.",
  },
  {
    q: "What configurations are available?",
    a: "The project offers 2 BHK, 3 BHK, 3.5 BHK and 4 BHK premium apartments along with exclusive retail spaces.",
  },
  {
    q: "What is the starting price?",
    a: "Premium 2 BHK apartments start at ₹ 1.47 Cr* onwards. Retail spaces start at ₹ 3.00 Cr* onwards.",
  },
  {
    q: "What amenities are offered?",
    a: "World-class amenities including swimming pool, gym, clubhouse, spa, badminton, yoga deck, kids play area, jogging track and 24x7 security.",
  },
  {
    q: "Is the project RERA approved?",
    a: "Yes. The project is RERA registered. Full RERA details shared upon enquiry.",
  },
  {
    q: "How do I schedule a site visit?",
    a: `Call us directly at ${SITE?.phone || "+91 8087536102"} or fill the enquiry form and our expert will arrange a complimentary site visit.`,
  },
];

export const DISCLAIMER = `Disclaimer: This is not the official developer website. This website is operated by Bhima Kamble, an authorized channel partner for Godrej Elaris, for informational and marketing purposes. All information, images, floor plans and prices mentioned on this website are indicative only and subject to change without notice. The actual product and offerings may differ. Please verify details with the developer before booking.`;
